export const CLOUDINARY_ROUTE_START = 'res.cloudinary.com'
export const CLOUDINARY_BASE_PATH = `https://${CLOUDINARY_ROUTE_START}/benchmarkminerals`
export const CLOUDINARY_PATH = `${CLOUDINARY_BASE_PATH}/image/upload`

export const CLOUDINARY_MODIFIERS_BY_DEFAULT = [
  'f_avif',
  'q_auto',
  'g_auto',
  'dpr_auto',
]

export const CLOUDINARY_QUERY_STRINGS = '?_i=AA'

export const CLOUDINARY_IMAGE_SIZES = {
  'hero-image': ['h_300', 'w_600', 'c_fill', 'g_auto', 'dpr_auto'],
  magazine: ['w_200', 'h_270', 'c_scale', 'dpr_auto'],
  presentation: ['w_370', 'c_scale', 'dpr_auto'],
  'video-thumbnail': ['w_500', 'c_scale', 'dpr_auto'],
  'membership-thumbnail': ['w_700', 'c_scale', 'dpr_auto'],
  'membership-hero': ['w_1300', 'c_scale', 'dpr_auto'],
  'event-card': ['w_500', 'c_fill', 'g_auto', 'f_auto', 'q_auto', 'dpr_auto'],
  'event-card-mobile': [
    'w_350',
    'c_fill',
    'g_auto',
    'f_auto',
    'q_auto',
    'dpr_auto',
  ],
  'event-detail': ['w_950', 'c_fill', 'g_auto', 'f_auto', 'q_auto', 'dpr_auto'],
  'event-detail-mobile': [
    'w_420',
    'c_fill',
    'g_auto',
    'f_auto',
    'q_auto',
    'dpr_auto',
  ],
  'market-hero': ['w_1300', 'c_fill', 'q_auto', 'dpr_auto'],
  'market-hero-mobile': ['w_1024', 'c_fill', 'q_auto', 'dpr_auto'],
  'report-thumbnail': ['w_250', 'h_296', 'c_fill', 'q_auto', 'dpr_auto'],
}

export const CLOUDINARY_IMAGE_SIZE = {
  HERO_IMAGE: ['h_300', 'w_600', 'c_fill', 'g_auto'],
  MAGAZINE: ['w_200', 'h_270', 'c_scale'],
  PRESENTATION: ['w_370', 'c_scale'],
  VIDEO_THUMBNAIL: ['w_500', 'c_scale'],
  ARTICLE_THUMBNAIL: ['w_700', 'c_scale'],
  ARTICLE_HERO: ['w_1300', 'c_scale'],
  EVENT_CARD: ['w_500', 'c_fill', 'g_auto', 'f_auto', 'q_auto'],
  EVENT_CARD_MOBILE: ['w_350', 'c_fill', 'g_auto', 'f_auto', 'q_auto'],
  EVENT_DETAIL: ['w_950', 'c_fill', 'g_auto', 'f_auto', 'q_auto'],
  EVENT_DETAIL_MOBILE: ['w_420', 'c_fill', 'g_auto', 'f_auto', 'q_auto'],
  MARKET_HERO: CLOUDINARY_IMAGE_SIZES['market-hero'],
  MARKET_HERO_MOBILE: CLOUDINARY_IMAGE_SIZES['market-hero-mobile'],
  REPORT_THUMBNAIL: CLOUDINARY_IMAGE_SIZES['report-thumbnail'],
} as const
